import { useEffect } from 'react';

import { useTranslation } from 'react-i18next';

import { useDashboardConfig } from '@/hooks/useDashboardConfig';
import { useAppDispatch } from '@/hooks/redux-helpers';

import { useProfileContext } from '@/features/context/ProfileContext';
import { refreshUser } from '@/features/user/store/user.actions';
import { SCAList as SCABlock } from '@/features/sca/components/SCAList';

import { UserTypes } from '@/features/user/store/user.model';

import { MainInformation } from './MainInformation';
import { UserTag } from './UserTag';
import { UserWallet } from './UserWallet';
import { UserCard } from './UserCard';

export function UserOverview() {
  const { t } = useTranslation();

  const dispatch = useAppDispatch();
  const config = useDashboardConfig();
  const { user } = useProfileContext();

  useEffect(() => {
    dispatch(refreshUser(user.userId));
  }, [dispatch, user.userId]);

  if (!user) return null;

  return (
    <div className="py-7 flex flex-col gap-7">
      <h4 className="typo-h4-bold text-secondary">{t('pages.currentProfiles.profile.tabs.title.overview')}</h4>
      <MainInformation />
      <UserTag />
      <UserWallet />
      <UserCard />
      {user.userTypeId === UserTypes.naturalPerson && config?.settings.sca && <SCABlock />}
    </div>
  );
}
